// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--1AXXX","logo":"Footer-module--logo--31sya","contact":"Footer-module--contact--1owNH"};